// extracted by mini-css-extract-plugin
export default {"py-chats":"chats_py-chats__pYEUn","chatContainer":"chats_chatContainer__rHzNS","chats":"chats_chats__niW-i","message":"chats_message__sMvAy"};